<template>
  <textarea
      class="block p-2 w-full text-base rounded border border-grey-25"
      :class="classes"
      :readonly="readonly"
      :placeholder="placeholder"
      :name="name"
      :value="value"
      :disabled="disabled"
      :id="`textarea-${uuid}`"
  />
</template>
<script>
import input from 'Mixins/input'
import uuid from 'Mixins/uuid'

export default {
  name: 'InputTextArea',
  mixins: [input, uuid],
  computed: {
    classes () {
      return {
        'bg-red-200': this.error,
      }
    }
  }
}
</script>
